import { render, staticRenderFns } from "./handle-model.vue?vue&type=template&id=1f1bd584&"
import script from "./handle-model.vue?vue&type=script&lang=js&"
export * from "./handle-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports